import { graphql, PageProps } from "gatsby";
import React, { FC, useState } from "react";
import ContentScreen from "../components/ContentScreen";
import Seo from "../components/SEO";
import Sidebar from "../components/Sidebar";

const Home: FC<PageProps> = ({ data }: any) => {
  const [open, setOpen] = useState(false);
  const images = data.allContentfulSkills.nodes;
  const testimonials = data.allContentfulTestimonial.nodes;
  const projects = data.allContentfulProjects.nodes;
  return (
    <div className="flex">
      <Seo />
      <Sidebar open={open} />
      <div className="md:w-32" />
      <ContentScreen
        images={images}
        testimonials={testimonials}
        projects={projects}
        open={open}
        setOpen={setOpen}
      />
    </div>
  );
};

export default Home;

export const query = graphql`
  query MyQuery {
    allContentfulSkills(sort: { fields: createdAt }) {
      nodes {
        title
        id
        image {
          gatsbyImageData(width: 40)
        }
      }
    }
    allContentfulTestimonial(sort: { fields: createdAt }) {
      nodes {
        id
        name
        designation
        review {
          review
        }
        profileImage {
          gatsbyImageData(placeholder: TRACED_SVG)
        }
      }
    }
    allContentfulProjects {
      nodes {
        id
        name
        technologies
        slug
        repo
        image {
          gatsbyImageData(placeholder: BLURRED)
        }
      }
    }
  }
`;
